import * as types from '../../../constants/actionTypes';
// import * as auth from '../../../../tools/auth0.cred';
import * as api from '../../../tools/apiConfig';
import jQuery from 'jquery';
import axios from 'axios';
import constant from '../../../constants/constant'
import { browserHistory } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as url from '../../../tools/config';
import openSocket from 'socket.io-client';
let environment = process.env.REACT_APP_NODE_ENV ? process.env.REACT_APP_NODE_ENV : 'development'
const socket = openSocket(url.getURLForServer(process.env.REACT_APP_NODE_ENV).SOCKET_URL);
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
const google = window.google;

export function signUpUser(signupdata) {
	return function (dispatch, getState) {
		axios.post(api.SIGN_UP_USER, JSON.stringify(signupdata), {
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
					response.data.data.userData.success = true;
					return dispatch({ type: types.SIGN_UP_USER, userData: response.data.data.userData });
				}
				else {
					toast.error(response.data.message);
					response.data.data = {};
					response.data.data.userData = {};
					response.data.data.userData.success = false;
					return dispatch({ type: types.SIGN_UP_USER, userData: response.data.data.userData ? response.data.data.userData : {} });
				}
			})
			.catch(function (error) {
				toast.error(error);
			});
	}
}


export function adminLogin(signindata) {
	return function (dispatch, getState) {
		axios.post(api.ADMIN_LOGIN, JSON.stringify(signindata), {
			headers: {
				'Content-Type': 'application/json'
			}
    })
			.then(function (response) {
				console.log("======================ADMIN++++++++++++++++++++++++===---------", response)
				if (response.data.code == 200) {
					
					return dispatch({ type: types.ADMIN_SIGNIN_FAIL, data: response.data.data });
	
       			
				}

				else {
					toast.error(response.data.message);
					response.data.data = {};
					response.data.data.success = false;
					return dispatch({ type: types.ADMIN_SIGNIN_FAIL, data: response.data.data });
				}
			})
			.catch(function (error) {
				// toast.error(error);
			});
	}
}

export function forgotPassword(data) {
	return function (dispatch, getState) {
		axios.post(api.FORGOT_PASSWORD, JSON.stringify(data), {
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message)
					setTimeout(function () {
						response.data.data.success = true;
						return dispatch({ type: types.FORGOT_PASSWORD, data: response.data.data });
					}, 3000)


				}
				else {
					toast.error(response.data.message)
					response.data.data = {};
					response.data.data.success = false;
					return dispatch({ type: types.FORGOT_PASSWORD, data: response.data.data });
				}
			})
			.catch(function (error) {
				toast.error(error);
			});
	}
}

export function resetPassword(data) {
	return function (dispatch, getState) {
		axios.post(api.RESET_PASSWORD, JSON.stringify(data), {
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
					response.data.data.success = true;
					return dispatch({ type: types.RESET_PASSWORD, data: response.data.data });
				}
				else {
					toast.error(response.data.message);
					response.data.data = {};
					response.data.data.success = false;
					return dispatch({ type: types.RESET_PASSWORD, data: response.data.data });
				}
			})
			.catch(function (error) {
				toast.error(error);
			});
	}
}

export function activateAccount(data) {
	return function (dispatch, getState) {
		axios.post(api.ACTIVATE_ACCOUNT, JSON.stringify(data), {
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
					response.data.data.success = true;
					return dispatch({ type: types.ACTIVATE_ACCOUNT, data: response.data.data });
				}
				else {
					toast.error(response.data.message);
					response.data.data.success = false;
					return dispatch({ type: types.ACTIVATE_ACCOUNT, data: response.data.data });
				}
			})
			.catch(function (error) {
				toast.error(error);
			});
	}
}


export function changeEmail(data) {
	return function (dispatch, getState) {
		axios.post(api.CHANGE_EMAIL, JSON.stringify(data), {
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
				}
				else {
					toast.error(response.data.message);
				}
			})
			.catch(function (error) {
				toast.error(error);
			});
	}
}

export function unLockAccount(data) {
	return function (dispatch, getState) {
		axios.post(api.UNLOCK_ACCOUNT, JSON.stringify(data), {
			headers: {
				'Content-Type': 'application/json'
			}
		})
			.then(function (response) {
				if (response.data.code == 200) {
					toast.info(response.data.message);
					response.data.data.success = true;
					return dispatch({ type: types.UNLOCK_ACCOUNT, data: response.data.data });
				}
				else {
					toast.error(response.data.message);
					response.data.data.success = false;
					return dispatch({ type: types.UNLOCK_ACCOUNT, data: response.data.data });
				}
			})
			.catch(function (error) {
				toast.error(error);
			});
	}
}
